module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"amount":"@:labels.amount","annualPayment":"@:labels.annualPayment","creditLimit":"@:labels.creditLimit","monthlyPayment":"@:labels.monthlyPayment","title":"@:labels.liabilities"},"fr":{"amount":"@:labels.amount","annualPayment":"@:labels.annualPayment","creditLimit":"@:labels.creditLimit","monthlyPayment":"@:labels.monthlyPayment","title":"@:labels.liabilities"}}')
  delete Component.options._Ctor
}
